<div class="create-company-modal">
  <div class="create-company-modal__header">
    <div>
      <h2 class="create-company-modal__title">
        {{ "TITLES.COMPANY_CREATION" | translate }}
      </h2>
      <p class="create-company-modal__subtitle">
        {{ "COMPONENTS.COMPANIES.CREATE_COMPANY" | translate }}
      </p>
    </div>

    <button
      type="button"
      class="create-company-modal__close default-transparent-btn"
      [attr.aria-label]="'BUTTONS.CANCEL' | translate"
      (click)="activeModal.dismiss('cancel')"
    >
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M12.7 4.7L11.3 3.3L8 6.6L4.7 3.3L3.3 4.7L6.6 8L3.3 11.3L4.7 12.7L8 9.4L11.3 12.7L12.7 11.3L9.4 8L12.7 4.7Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>

  <form
    class="create-company-modal__form"
    [formGroup]="formModel.form"
    (ngSubmit)="submitForm()"
  >
    <div class="create-company-modal__panel">
      <div class="create-company-modal__grid">
        <div class="create-company-modal__field create-company-modal__field--wide">
          <label for="company-input" class="form-label required">
            {{ "INPUTS.COMPANY_NAME" | translate }}
          </label>

          <input
            id="company-input"
            type="text"
            [placeholder]="'INPUTS.COMPANY_NAME' | translate"
            class="form-input"
            [class.is-invalid]="
              (nameFormControl.touched || formModel.form.dirty) &&
              nameFormControl.errors
            "
            [class.is-valid]="!nameFormControl.errors"
            [formControlName]="formModel.fieldNames.name"
          />

          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: nameFormControl.errors }"
          ></ng-container>
        </div>

        <div class="create-company-modal__field create-company-modal__field--wide">
          <label for="description-textarea" class="form-label">
            {{ "INPUTS.DESCRIPTION" | translate }}
          </label>

          <textarea
            id="description-textarea"
            class="form-input form-textarea create-company-modal__textarea"
            [class.is-invalid]="
              descriptionFormControl.touched && descriptionFormControl.errors
            "
            [class.is-valid]="
              descriptionFormControl.touched && !descriptionFormControl.errors
            "
            [formControlName]="formModel.fieldNames.description"
          ></textarea>

          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: descriptionFormControl.errors }"
          ></ng-container>
        </div>

        <div class="create-company-modal__field create-company-modal__field--wide">
          <label class="form-label">
            {{ "INPUTS.LOGO" | translate }}
          </label>

          @if (previewUrl$ | async; as previewUrl) {
            <div class="create-project-cover-block create-company-modal__cover-block">
              <div class="create-project-cover-preview create-project-cover-preview--filled create-company-modal__cover-preview">
                <img [src]="previewUrl" [alt]="'INPUTS.LOGO' | translate" />
              </div>

              <div class="create-project-cover-actions create-company-modal__cover-actions">
                <app-file-upload
                  [showPreview]="false"
                  [fileExtensions]="acceptedExtensions"
                  [path]="titleImagePath"
                  [fileTitle]="'title'"
                  [isTemporaryFiles]="true"
                  (uploadedFileEvent)="onUploadFile($event)"
                />

                <button
                  type="button"
                  class="form-secondary-btn create-project-remove-cover-btn"
                  (click)="onDeleteFile()"
                >
                  {{ "BUTTONS.REMOVE" | translate }}
                </button>
              </div>
            </div>
          } @else {
            <div class="create-project-cover-block create-company-modal__cover-block">
              <div class="create-project-cover-preview create-company-modal__cover-preview">
                <span>{{ "INPUTS.LOGO" | translate }}</span>
              </div>

              <div class="create-project-cover-actions create-company-modal__cover-actions">
                <app-file-upload
                  [showPreview]="false"
                  [fileExtensions]="acceptedExtensions"
                  [path]="titleImagePath"
                  [fileTitle]="'title'"
                  [isTemporaryFiles]="true"
                  (uploadedFileEvent)="onUploadFile($event)"
                />
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="create-project-actions create-company-modal__actions">
      <button
        type="button"
        class="form-secondary-btn"
        (click)="activeModal.dismiss('cancel')"
      >
        {{ "BUTTONS.CANCEL" | translate }}
      </button>

      <button
        type="submit"
        class="form-primary-btn"
        [disabled]="formModel.form.invalid"
      >
        {{ "BUTTONS.CREATE" | translate }}
      </button>
    </div>
  </form>
</div>

<ng-template #validationErrorsTemplate let-errors="errors">
  @if (errors) {
    <ul class="invalid-feedback">
      @if (errors["required"]) {
        <li>{{ "ERRORS.REQUIRED" | translate }}</li>
      }

      @if (errors["maxlength"]) {
        <li>
          {{
            "ERRORS.MAXLENGTH"
              | translate
                : { requiredLength: errors["maxlength"].requiredLength }
          }}
        </li>
      }
    </ul>
  }
</ng-template>
